export class BackedUpByResourceTypeDataInner {
    'resourceType';
    'eon';
    'generalPurpose';
    'notProtected';
    'excluded';
    'initialClassification';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "eon",
            "baseName": "eon",
            "type": "number",
            "format": ""
        },
        {
            "name": "generalPurpose",
            "baseName": "generalPurpose",
            "type": "number",
            "format": ""
        },
        {
            "name": "notProtected",
            "baseName": "notProtected",
            "type": "number",
            "format": ""
        },
        {
            "name": "excluded",
            "baseName": "excluded",
            "type": "number",
            "format": ""
        },
        {
            "name": "initialClassification",
            "baseName": "initialClassification",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackedUpByResourceTypeDataInner.attributeTypeMap;
    }
    constructor() {
    }
}
